import { render, staticRenderFns } from "./notificationRecord.vue?vue&type=template&id=4ea398e1&scoped=true"
import script from "./notificationRecord.vue?vue&type=script&lang=js"
export * from "./notificationRecord.vue?vue&type=script&lang=js"
import style0 from "./notificationRecord.vue?vue&type=style&index=0&id=4ea398e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea398e1",
  null
  
)

export default component.exports